// @flow
import React from 'react';
import { toast, ToastOptions } from 'react-toastify';
import { colors } from 'bench-style-constants';

import { Icon, Toast } from './index';

export const toastSuccess = (title: string, message: string, options: ?ToastOptions) => {
  toast(
    <Toast
      icon={<Icon color={colors.bonsai} icon="check" size="32px" />}
      aria-label="Toast Success"
      message={message}
      title={title}
    />,
    { autoClose: 4000, ...options },
  );
};

export const toastError = (title: string, message: string, options: ?ToastOptions) => {
  toast(
    <Toast
      icon={<Icon color={colors.copper} icon="close" size="32px" />}
      message={message}
      title={title}
    />,
    { autoClose: false, ...options },
  );
};
